module.exports = __webpack_public_path__ + "da6a1540a0e44d13102a5f2ab868eed8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-3.png
// module id = 3224
// module chunks = 0